import React from 'react';
import banner from '../../images/banners/banner_2.jpg';

function BannerLeft() {
	return (
		<div className='banner--left'>
			<img alt='banner' src={banner} />
		</div>
	);
}

export default BannerLeft;
